export function isTopLevelSelected(editor, index) {
    if (editor.selection == null) {
        return false;
    }
    let startIdx = editor.selection.anchor.path[0];
    let endIdx = editor.selection.focus.path[0];
    if (endIdx < startIdx) {
        [startIdx, endIdx] = [endIdx, startIdx];
    }
    return startIdx <= index && index <= endIdx;
}
//# sourceMappingURL=isTopLevelSelected.js.map